<form [formGroup]="form" (ngSubmit)="onSubmit()" class="gap-2">
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
    <!-- Nombre -->
    <div>
      <app-metro-form-input formControlName="name" [placeholder]='"::Name" | abpLocalization' size="md" type="text">
      </app-metro-form-input>
    </div>

    <!-- Apellido -->
    <div>
      <app-metro-form-input formControlName="surname" [placeholder]='"::Surname" | abpLocalization' size="md" type="text">
      </app-metro-form-input>
    </div>

    <!-- Contraseña -->
    <div>
      <app-metro-form-input formControlName="password" [placeholder]='"::Password" | abpLocalization' size="md"
        type="password" autocomplete="new-password">
      </app-metro-form-input>
    </div>

    <!-- Confirmar contraseña -->
    <div>
      <app-metro-form-input formControlName="confirmPassword" [placeholder]='"::ConfirmPassword" | abpLocalization'
        size="md" type="password" autocomplete="new-confirm-password">
      </app-metro-form-input>
    </div>

    <!-- Correo electrónico -->
    <div>
      <app-metro-form-input formControlName="email" [placeholder]='"::Email" | abpLocalization' size="md" type="email">
      </app-metro-form-input>
      @if (form.get('email')?.invalid && form.get('email')?.touched) {
        <p class="text-xs text-red-500 mt-1">
          @if (form.get('email')?.errors?.['required']) {
            {{ '::ThisFieldIsRequired' | abpLocalization }}
          } @else if (form.get('email')?.errors?.['email']) {
            {{ '::InvalidEmail' | abpLocalization }}
          }
        </p>
      }
    </div>

    <!-- Confirmar correo electrónico -->
    <div>
      <app-metro-form-input formControlName="confirmEmail" [placeholder]='"::ConfirmEmail" | abpLocalization' size="md" type="email">
      </app-metro-form-input>
      @if (form.get('confirmEmail')?.invalid && form.get('confirmEmail')?.touched) {
        <p class="text-xs text-red-500 mt-1">
          @if (form.get('confirmEmail')?.errors?.['required']) {
            {{ '::ThisFieldIsRequired' | abpLocalization }}
          } @else if (form.get('confirmEmail')?.errors?.['email']) {
            {{ '::InvalidEmail' | abpLocalization }}
          } @else if (form.get('confirmEmail')?.errors?.['emailMismatch']) {
            {{ '::EmailsDoNotMatch' | abpLocalization }}
          }
        </p>
      }
    </div>

    <!-- Teléfono -->
    <div>
      <app-metro-form-input formControlName="phoneNumber" [placeholder]='"::Telephone" | abpLocalization' size="md"
        type="text">
      </app-metro-form-input>
    </div>

     <div>
      <app-metro-form-input formControlName="documentNumber" [placeholder]='"::DniOrCuit" | abpLocalization' size="md"
        type="number" >
      </app-metro-form-input>
    </div>

    <!-- Dirección -->
    <div>
      <app-metro-form-input formControlName="address" [placeholder]='"::Address" | abpLocalization' size="md"
        type="text">
      </app-metro-form-input>
    </div>
  </div>

  <input type="text" name="extraField" style="display:none" tabindex="-1" formControlName="extraField">

  <app-metro-form-select [options]="pickups$ | async" formControlName="pickUpId"
    [placeholder]="'::PickupPoints' | abpLocalization" size="md" selectedBackgroundClass="bg-metro-blue"
    style="display:none">
  </app-metro-form-select>

</form>
